/**
 * @param {string} selector
 */
export function selectorNotFound(selector) {
 return `Selector ${selector} no encontrado.`
}